import B1 from "../../Images/New/FileView/1.png";
import B2 from "../../Images/New/FileView/2.png";
import B3 from "../../Images/New/FileView/3.png";
import B4 from "../../Images/New/FileView/4.png";

let Products = [
  {
    name: "GSTR 9 & GSTR 9C",
    title: "GSTR 9 & GSTR 9C",
    image: B1,
    listItems: [
      "Auto-fill GST data from GSTR 1, 2A, and 3B data",
      "On-screen Comparison of Books data with Portal Data",
      "Direct data view button of GSTR 3B/2A/2B/1/Purchase & Sale",
      "Import / Export Tax data, to/from Excel, JSON, etc",
      "Prepare GSTR 9C form for complete auditing",
      "View auto-populated details from GSTR 9",
      "Easy and Keyboard Friendly data entry with help",
    ],
  },
  {
    name: "GSTR 1",
    title: "GSTR 1",
    image: B2,
    listItems: [
      "Preparation and e-filing of data",
      "Import data in a click from Tally, Excel and JSON",
      "Download and Import Return data from GST Portal",
      "Return Summary view of Outward Supply Data",
      "Pre-Validation facility to identify errors before uploading return",
      "Reconciliation of GSTR-1 data with Accounts data",
      "Summarised as well as Detailed Reports of GSTR-1",
      "Rate-wise Analysis of GSTR-1",
      "Collecting Return filing status",
      "Easy and Keyboard friendly addition, deletion and modification",
    ],
  },
  {
    name: "GSTR 3B",
    title: "GSTR 3B",
    image: B3,
    listItems: [
      "Collect auto-populated GSTR 3B from Portal",
      "Autofill Outward & Inward data from Accounts & GSTR 2B",
      "e-file GSTR-3B directly or fill 3B data on Portal",
      "Pre-Validation facility to trace errors",
      "ITC set-off as per amended rules and provisions of the Act",
      "Check ITC claim summary, ITC Comparison & ITC as per GSTR-2B while preparing GSTR 3B",
      "Import data in a single click from an Excel Sheet",
      "Collecting Return filing status",
      "Keyboard-friendly data preparation.",
    ],
  },
  {
    name: "GSTR 2A & GSTR 2B Reconciliation",
    title: "GSTR 2A & GSTR 2B Reconciliation",
    image: B4,
    listItems: [
      "Collect GSTR-2A and 2B data with a single click from GST Portal",
      "Reconciling data of GSTR 2A/2B with Accounts & GSTR 3B data",
      "Reconciling Multi-Period data in a single go",
      "Invoice & Party Wise Reconciliation",
      "Claim Maximum ITC with Intelligent 2A/2B Reconciliation module",
      "Comprehensive data viewer – Horizontal / Vertical view",
      "Important yet easy matching status – Matched, Mismatched, missed by Account, missed by Vendor, Invoice no., POS, etc.",
      "Get reports of Matched, mismatched as consolidated or party-wise",
    ],
  },
];

export default Products;

